/**
 * Created by fers on 05.02.16.
 */
/* global window, atob, btoa */

import Grid from './Grid.react';
import {FormattedMessage} from 'react-intl';

import React from 'react';
import PropTypes from 'prop-types';
import {getQueryParams} from '../../common/util/QueryParams';
import LoadingButton from '../fw/LoadingButton.react';
// JS file, no TS types

export const defaultPageSize = 200;

export function processPagingParams(variables) {
    if (!variables) {
        return;
    }

    let queryArgs = "";
    if (typeof window === 'object' && 'location' in window) {
        queryArgs = window.location.search || '';
    }

    let queryParams = getQueryParams(queryArgs || '');
    if (!variables.after && queryParams.after) {
        variables.after = queryParams.after;
    }
    if (!variables.before && queryParams.before) {
        variables.before = queryParams.before;
    }

    return variables;
}

export default class PagingGrid extends React.Component {
    static propTypes = {
        edges: PropTypes.object.isRequired,
        pageInfo: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        renderLink: PropTypes.bool,
    };

    static defaultProps = {
        renderLink: true
    };

    constructor(props) {
        super(props);

        this.state = {
            pageSize: defaultPageSize,
            hasNextPage: props.pageInfo ? props.pageInfo.hasNextPage : false,
            hasPreviousPage: false,
            pagination: 0,
            maxPage: props.pageInfo.hasNextPage ? 1 : 0,
            paginating: false,
        };
    }

    nextPage = () => {
        return new Promise((resolve, reject) => {
            if ((this.props.relay && this.props.relay.pendingVariables) || this.state.paginating) {
                resolve();
                return;
            }
            if (!(this.props.pageInfo && this.props.pageInfo.hasNextPage)) {
                resolve();
                return;
            }
            const cursor = this.props.pageInfo.endCursor;
            this.setState({ paginating: true });
            this.props.relay.setVariables({ after: cursor, before: null, first: this.state.pageSize, last: null }, (state) => {
                if (state.done) {
                    this.setState({
                        pagination: this.state.pagination + 1,
                        maxPage: this.state.maxPage < this.state.pagination + 1 ? this.state.pagination + 1 : this.state.maxPage,
                        paginating: false,
                    });
                    resolve();
                } else if (state.error) {
                    this.setState({ paginating: false });
                    reject();
                }
            });
        });
    };

    previousPage = () => {
        return new Promise((resolve, reject) => {
            if ((this.props.relay && this.props.relay.pendingVariables) || this.state.paginating) {
                resolve();
                return;
            }
            const pageInfo = this.props.pageInfo || {};
            const startIndex = pageInfo.startCursor ? parseInt((atob(pageInfo.startCursor).split(':')[1] || '0'), 10) : 0;
            const newAfterOffset = Math.max(startIndex - this.state.pageSize, 0);

            const applyState = () => {
                this.setState({
                    pagination: Math.max(this.state.pagination - 1, 0),
                    paginating: false,
                });
            };

            if (newAfterOffset === 0) {
                this.setState({ paginating: true });
                this.props.relay.setVariables({ after: null, before: null, first: this.state.pageSize, last: null }, (state) => {
                    if (state.done) {
                        applyState();
                        resolve();
                    } else if (state.error) {
                        this.setState({ paginating: false });
                        reject();
                    }
                });
            } else {
                const newAfter = btoa('arrayconnection:' + String(newAfterOffset));
                this.setState({ paginating: true });
                this.props.relay.setVariables({ after: newAfter, before: null, first: this.state.pageSize, last: null }, (state) => {
                    if (state.done) {
                        applyState();
                        resolve();
                    } else if (state.error) {
                        this.setState({ paginating: false });
                        reject();
                    }
                });
            }
        });
    };

    render() {
        const edgesArray = (this.props.edges && this.props.edges.edges) ? this.props.edges.edges : [];
        let list = edgesArray.map(({node}) => node);

        const pageInfo = this.props.pageInfo || {};
        const startIndex = pageInfo.startCursor ? parseInt((atob(pageInfo.startCursor).split(':')[1] || '0'), 10) : 0;
        const relayVars = (this.props.relay && this.props.relay.variables) ? this.props.relay.variables : {};
        const afterOffset = relayVars.after ? parseInt((atob(relayVars.after).split(':')[1] || '0'), 10) : 0;
        const isFullPage = edgesArray.length >= this.state.pageSize;
        const isFirstPage = (!relayVars.before && afterOffset === 0 && startIndex === 0);
        const showPrev = !isFirstPage && (!!pageInfo.hasPreviousPage || startIndex > 0 || afterOffset > 0);
        const showNext = !!pageInfo.hasNextPage;
        const isPending = !!(this.props.relay && this.props.relay.pendingVariables) || this.state.paginating;

        return (
            <div>
                <Grid {...this.props} list={list}/>

                <div aria-label="..." className="btn-group" role="group">
                    {showPrev ? (
                        <LoadingButton className="btn btn-default" disabled={isPending} onClick={this.previousPage}>
                            <FormattedMessage defaultMessage="Load previous…" id="msg.loadPrevious" />
                        </LoadingButton>
                    ) : null}
                    {showNext ? (
                        <LoadingButton className="btn btn-default" disabled={isPending} onClick={this.nextPage}>
                            <FormattedMessage defaultMessage="Load more…" id="msg.loadMore" />
                        </LoadingButton>
                    ) : null}
                </div>
            </div>
        );
    }
}
